export class Trigger {

    constructor ( target = '.js-trigger', options = {} ) {
        this.target = target;

        this.options = {
            activeClass: 'js-active',
            closeTrigger: 'js-trigger--close',
            closeMain: false,
            scroll: true,
            ...options
        }
    }

    init () {
        this.$triggers = Array.from( document.querySelectorAll( this.target ) );
        this.$close = Array.from( document.querySelectorAll( `.${this.options.closeTrigger}` ) );

        this.$triggers.forEach( $trigger => {
            const elClone = $trigger.cloneNode( true );

            const parent = $trigger.parentElement;

            parent.replaceChild( elClone, $trigger );

            $trigger = parent.querySelector( this.target );

            let $activates;
            if ( !!$trigger.dataset.activates ) {
                if ( $trigger.dataset.activates === 'parent' ) {
                    $activates = $trigger.parentElement;
                } else {
                    $activates = document.querySelector( `#${$trigger.dataset.activates}` )
                }
            } else {
                $activates = document.querySelector( $trigger.href.replace( /^.*#/, '#' ) )
            }

            $trigger.addEventListener( 'click', this.open.bind( this, $trigger, $activates ) )
        } );
    }

    open ( $trigger, $activates ) {
        let scroll = this.options.scroll;
        if ( $trigger.hasAttribute( 'data-scroll' ) ) {
            scroll = ( $trigger.dataset.scroll === 'true' );
        }

        let main = this.options.closeMain;
        if ( $trigger.hasAttribute( 'data-close-main' ) ) {
            main = ( $trigger.getAttribute( 'data-close-main' ) === 'true' );
        }

        if ( main ) {
            const $main = document.querySelector( 'main' );
            $main.addEventListener( 'click', () => {
                const $open = Array.from( document.querySelectorAll( `.${this.options.activeClass}` ) );

                $open.forEach( $item => {
                    $item.classList.remove( this.options.activeClass );
                } )

                if ( !scroll ) {
                    document.body.classList.remove( 'js-no-scroll' );
                }
            } )
        }

        if ( $trigger.hasAttribute( 'data-toggle' ) ) {
            $trigger.classList.toggle( this.options.activeClass );
            $activates.classList.toggle( this.options.activeClass );

            if ( !scroll ) {
                document.body.classList.toggle( 'js-no-scroll' );
            }
        } else {
            $activates.classList.add( this.options.activeClass );

            if ( !scroll ) {
                document.body.classList.add( 'js-no-scroll' );
            }
        }

        if( $trigger.hasAttribute( 'data-mobile' ) ) {
            document.querySelector( 'body' ).classList.toggle( 'js-mobile-active' );
        }
    }

    destroy() {
        this.$triggers.forEach( $trigger => {
            let $activates;
            if ( !!$trigger.dataset.activates ) {
                if ( $trigger.dataset.activates === 'parent' ) {
                    $activates = $trigger.parentElement;
                } else {
                    $activates = document.querySelector( `#${$trigger.dataset.activates}` )
                }
            } else {
                $activates = document.querySelector( $trigger.href.replace( /^.*#/, '#' ) )
            }

            $trigger.removeEventListener( 'click', this.open.bind( this, $trigger, $activates ) )
        });
    }
}